import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { DEFAULT_INTERRUPTSOURCES, Idle,IdleExpiry, SimpleExpiry  } from '@ng-idle/core';
import { MomentModule } from 'ngx-moment';

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...appConfig.providers, // Include existing providers from appConfig, 
  ],
})
  .catch((err) => console.error(err));